var render = function render(_c,_vm){return _c('span',{staticClass:"txt_sub emph_color"},[_vm._t("default",function(){return [_vm._v("Error")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }